import { createDataNode } from '../nodeFactory/dataNodeUtils'
import type { OOICssConfig, TPAWidgetDefinition } from '@wix/thunderbolt-becky-types'
import { envRefs } from '../refs/refsFactory'
import type { WidgetData } from '@wix/thunderbolt-symbols'
import type { Ref } from '@wix/materializer'
import { BeckyModel } from '@wix/thunderbolt-becky-root'

export const TPAWidget = createDataNode<
	TPAWidgetDefinition['data'],
	{
		cssConfig: Ref<OOICssConfig>
		widgetSpecData: Ref<WidgetData[string]>
		appSettings: Ref<object | undefined>
		migratingToOoiWidgetIds: Ref<BeckyModel['migratingToOoiWidgetIds']>
	}
>({
	getDependencies: (dataItem: TPAWidgetDefinition['data']) => {
		return {
			cssConfig: envRefs.ooiCssConfig(dataItem.widgetId),
			widgetSpecData: envRefs.widgetSpecData(dataItem.appDefinitionId, dataItem.widgetId),
			appSettings: envRefs.ooiWidgetsAppSettings(dataItem.widgetId, dataItem.referenceId),
			migratingToOoiWidgetIds: envRefs.migratingToOoiWidgetIds,
		}
	},
	toViewItem: (dataItem: TPAWidgetDefinition['data'], __, { migratingToOoiWidgetIds, ...restDeps }) => {
		const isMigratingToOoi = migratingToOoiWidgetIds.includes(dataItem.widgetId)
		return { ...dataItem, isMigratingToOoi, ...restDeps }
	},
})
